module.exports = require("@swissquote/crafty-commons/packages/fancy-log.js");